import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import FFLogo from "../../../img/FREEFIT_LOGO_new.png";
import { CaretDownIcon, ProfileIcon, SearchIcon } from "./HomeIcons";

// The home page's own top bar — the legacy header is suppressed for V2 partners
// by the LegacyHeaderGate in shared/HomeRoute. No back control: home is the root
// of the flow and has nowhere to go back to.
function HomeTopBar({ locationLabel }) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <header className="hm-v2-topbar">
      <img src={FFLogo} alt="freefit" className="hm-v2-topbar-logo" />

      <button type="button" className="hm-v2-topbar-location" onClick={() => navigate("/address-select")}>
        <span className="hm-v2-topbar-location-text">{locationLabel || t("HOME_LOCATION_CHOOSE")}</span>
        <span className="hm-v2-topbar-caret">
          <CaretDownIcon />
        </span>
      </button>

      <div className="hm-v2-topbar-actions">
        <button
          type="button"
          className="hm-v2-topbar-icon-btn"
          aria-label={t("HOME_SEARCH_ARIA")}
          onClick={() => navigate("/fitExtendSelector")}
        >
          <SearchIcon />
        </button>
        <button
          type="button"
          className="hm-v2-topbar-icon-btn"
          aria-label={t("HOME_PROFILE_ARIA")}
          onClick={() => navigate("/profile")}
        >
          <ProfileIcon />
        </button>
      </div>
    </header>
  );
}

export default HomeTopBar;
